import axiosHook from '../axios';

export default {
  // 온라인 결제 정보 조회
  getPayment(params) {
    return axiosHook('post', `/api/smartropay/payment/${params.type}`, params);
  },

  // 사전결제, 미납결제 영수증 정보 조회
  getReceiptPaymentInfo(params) {
    return axiosHook('get', '/api/smartropay/payment/receipt', params);
  },
};
